import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import { useUploadCSVManagementCompany } from "src/services/admin/commands/transfers";
import SnackbarUtils from "src/utils/SnackbarUtils";

// ----------------------------------------------------------------------

type Props = { file: any };

export const SaveFileBtn = ({ file }: Props) => {
	const { mutate } = useUploadCSVManagementCompany();

	const handleOnSave = () => {
		mutate(file, {
			onSuccess: () => SnackbarUtils.success("Se ha subido el csv correctamente"),
			onError: () => SnackbarUtils.error("Error al subir el csv")
		});
	};

	return (
		<Stack sx={{ flex: 1, mt: 3 }}>
			<LoadingButton
				onClick={handleOnSave}
				sx={{ alignSelf: "flex-end" }}
				type='submit'
				variant='contained'
			>
				{"Guardar csv"}
			</LoadingButton>
		</Stack>
	);
};

export default SaveFileBtn;
